"use client";
import React from "react";

interface Props {
    text: string;
}

const CategoryDescriptionToggle = ({ text }: Props) => {
    return (
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm px-6 py-5">
            {/* 2-line clamp preview */}
            <p
                className="text-slate-500 text-sm leading-relaxed font-medium"
                style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                }}
            >
                {text}
            </p>

            {/* Anchor to full description section below FAQs */}
            <a
                href="#category-full-description"
                className="mt-2 inline-flex items-center gap-1.5 text-[10px] font-black uppercase tracking-[0.2em] text-[#D61C4E] hover:opacity-70 transition-opacity no-underline"
            >
                <span className="w-3 h-[1.5px] bg-[#D61C4E] rounded-full" />
                See More
            </a>
        </div>
    );
};

export default CategoryDescriptionToggle;
